import { SVGProps } from 'react';

const Citrus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.65 15.66A8 8 0 0 1 8.35 4.34M14 10l-5.5 5.5M6.15 10H14v7.85m7.66-.18a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z"
    />
  </svg>
);
export default Citrus;
